/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Telemedicine_Landing_TaglineInputs */

const en_service_telemedicine_landing_tagline = /** @type {(inputs: Service_Telemedicine_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual Care & Telemedicine`)
};

const fr_service_telemedicine_landing_tagline = /** @type {(inputs: Service_Telemedicine_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soins virtuels et télémédecine`)
};

/**
* | output |
* | --- |
* | "Virtual Care & Telemedicine" |
*
* @param {Service_Telemedicine_Landing_TaglineInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_telemedicine_landing_tagline = /** @type {((inputs?: Service_Telemedicine_Landing_TaglineInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Telemedicine_Landing_TaglineInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_telemedicine_landing_tagline(inputs)
	return fr_service_telemedicine_landing_tagline(inputs)
});